import BaseController from "./BaseController";
import http from "../../Store/baseHttp";
import ResponseObject from "../../DataObjects/ResponseObject";
// import UserObject from "../../DataObjects/UserObject";
// import FormData from "form-data";
import UserObject from "../../DataObjects/UserObject";
// import * as fs from 'fs';

class DashboardController extends BaseController {

  async index({ request, params }) {
    const url = new URL(request.url);
    const refreshValue = url.searchParams.get("refresh") ??false;
    try {
      let response = await http.get("/admin/dashboard/statistics" + url.search);
      const waitingListResponse = await http.get(
        "/admin/waitinglist" + url.search
      );
      const capsaResponse = await http.post("/admin/dashboard/capsatransactions",{
        refresh: refreshValue
      });
      const cooperativeStats = await http.get("/admin/cooperative/stats");
      const LoanStats = await http.get("/admin/loan/stats");
      const LoanTransactions = await http.get("/admin/loan/transactions"+ url.search);

      const waitingListData = ResponseObject.from(waitingListResponse);
      const capsaData = ResponseObject.from(capsaResponse);
      response = ResponseObject.from(response);
      response = ResponseObject.from(LoanTransactions);
      return { response, waitingListData, capsaData, cooperativeStats, LoanStats, LoanTransactions};
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  

  async post({ request }) {
    try {
      const formData = Object.fromEntries(await request.formData());

      const myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + UserObject.getUser().token);

      const transData = new FormData();
      Object.keys(formData).map((v) => transData.append(v, formData[v]));

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: transData,
        redirect: "follow",
      };

      const response = await (
        await fetch(
          "https://api.fedacash.com/api/request/create",
          requestOptions
        )
      ).json();

      return ResponseObject.from({ data: response });
      // return response;
    } catch (e) {
      return e?.response;
    }
  }

  static async submit(formData) {
    try {
      let response = await http.post(
        "/request/create",
        Object.fromEntries(await formData),
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }
}

export default DashboardController;
